import H from 'constants/httpMethod.const';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beUserInfo = actionEndpointBe('beUserInfo', H.get, 'authentication/user/info/this-salon/:salonId/', (options) => ({
  ...options,
  pin: false,
  inert: true,
  isMissingParams: false,
  fromDto: (json) => json?.results,
}));
